import qs from 'qs';

/**
 * 获取 URL 查询参数对象
 */
export const getQuery = (search?: string): Record<string, string> => {
    const searchStr = search ?? window.location.search;
    return qs.parse(searchStr, { ignoreQueryPrefix: true }) as Record<string, string>;
};

/**
 * 将对象序列化为 querystring
 */
export const toQueryString = (params: Record<string, any>): string => {
    return qs.stringify(params);
};

/**
 * 读取并消费 URL 上的 newchat 参数（外部落地页带关键词直接发起新对话）。
 * 取到值后立即从地址栏移除 newchat，其余 query 参数原样保留。
 * @returns newchat 关键词；不存在或为空时返回 null
 */
export const takeNewChatQuery = (): string | null => {
    try {
        const url = new URL(window.location.href);
        const raw = url.searchParams.get('newchat');
        const value = raw ? raw.trim() : '';
        if (!value) return null;
        url.searchParams.delete('newchat');
        const search = url.searchParams.toString();
        window.history.replaceState(null, '', `${url.pathname}${search ? `?${search}` : ''}${url.hash}`);
        return value;
    } catch {
        return null;
    }
};
